export default __webpack_public_path__ + "static/media/mayo.d0e87762.png";